import {KeasyBootstrap} from './keasy-bootstrap';

declare let window: KeasyBootstrap;

window.openSidebar = (): void => {
    const sidebar = document.querySelector('aside');

    if (!sidebar) {
        return;
    }

    if (!sidebar.classList.contains('sidebar--closed') && !sidebar.classList.contains('sidebar--open')) {
        sidebar.classList.add('sidebar--open');
    }

    sidebar.classList.replace('sidebar--closed', 'sidebar--open');
}

window.closeSidebar = (): void => {
    const sidebar = document.querySelector('aside');

    if (!sidebar) {
        return;
    }

    sidebar.classList.replace('sidebar--open', 'sidebar--closed');
}

function attachSidebarEvents() {
    const sidebar = document.querySelector('aside');

    if (!sidebar) {
        return;
    }

    sidebar.onclick = (event) => {
      // backdrop area check
      if (sidebar.clientWidth < event.x) {
        window.closeSidebar();
      }
    };
}

document.addEventListener('DOMContentLoaded', () => {
  attachSidebarEvents();
}, {once: true});
